// extracted by mini-css-extract-plugin
export default {"stars":"RatingStars_stars__yk3LH","starFilled":"RatingStars_starFilled__S8zsn","starHalf":"RatingStars_starHalf__1uaar","starEmpty":"RatingStars_starEmpty__1rAIJ"};